module.exports = __webpack_public_path__ + "static/media/sliders-h-square.6476bb5d.svg";